import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.lookit.pricepill');
import { Input } from '@angular/core';

@Component({
    selector: 'wiz-component-lookit-pricepill',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.lookit.pricepill/view.scss */
:host {
  display: block;
  min-width: 0;
}

.lookit-price-pill {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 6px;
  border: 1px solid transparent;
  border-radius: var(--lookit-radius-md);
  background: var(--lookit-color-surface-muted);
  padding: var(--lookit-space-3);
}

.lookit-price-pill__main {
  display: flex;
  min-width: 0;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--lookit-space-2);
}

.lookit-price-pill__label {
  flex: 1 1 auto;
  min-width: 0;
}

.lookit-price-pill__label,
.lookit-price-pill__listed,
.lookit-price-pill__chip {
  color: var(--lookit-color-text-muted);
  font-size: var(--lookit-font-size-xs);
  font-weight: var(--lookit-font-weight-bold);
  line-height: 1.2;
}

.lookit-price-pill__price {
  min-width: 0;
  color: var(--lookit-color-text);
  font-size: var(--lookit-font-size-lg);
  font-weight: var(--lookit-font-weight-black);
  line-height: 1.15;
  overflow-wrap: anywhere;
  text-align: right;
}

.lookit-price-pill__listed {
  text-decoration: none;
}

.lookit-price-pill__labels {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 5px;
}

.lookit-price-pill__chip {
  display: inline-flex;
  min-height: 22px;
  align-items: center;
  border-radius: var(--lookit-radius-pill);
  background: var(--lookit-color-surface);
  padding: 0 7px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lookit-price-pill.is-lowest {
  border-color: color-mix(in srgb, var(--lookit-color-price-drop) 42%, var(--lookit-color-surface));
  background: var(--lookit-color-price-drop-soft);
}

.lookit-price-pill.is-lowest .lookit-price-pill__price,
.lookit-price-pill.is-drop .lookit-price-pill__price {
  color: var(--lookit-color-price-drop);
}

.lookit-price-pill.is-drop {
  border-color: color-mix(in srgb, var(--lookit-color-lowest) 45%, var(--lookit-color-surface));
}`],
})
export class ComponentLookitPricepillComponent {
    @Input() effectivePrice: number | string = '';
    @Input() listedPrice: number | string = '';
    @Input() shippingIncluded: boolean = false;
    @Input() couponApplied: boolean = false;
    @Input() lowest: boolean = false;
    @Input() priceDrop: boolean = false;
    @Input() labels: Array<string | number> = [];
    @Input() label: string = '실구매가';

    public formatPrice(value: number | string): string {
        if (value === null || value === undefined || value === '') return '가격 확인 필요';
        if (typeof value === 'number') return `${new Intl.NumberFormat('ko-KR').format(value)}원`;
        return `${value}`;
    }

    public get displayEffectivePrice(): string {
        return this.formatPrice(this.effectivePrice);
    }

    public get displayListedPrice(): string {
        if (this.listedPrice === null || this.listedPrice === undefined || this.listedPrice === '') return '';
        return this.formatPrice(this.listedPrice);
    }

    public get visibleLabels(): string[] {
        const items: string[] = [];
        if (this.lowest) items.push('현재 최저');
        if (this.priceDrop) items.push('가격 하락');
        if (this.shippingIncluded) items.push('배송비 포함');
        if (this.couponApplied) items.push('공개 쿠폰 적용');
        if (Array.isArray(this.labels)) {
            this.labels.forEach((item) => {
                if (item !== null && item !== undefined && item !== '') items.push(`${item}`);
            });
        }
        return Array.from(new Set(items)).slice(0, 4);
    }

    public trackByLabel(_index: number, item: string): string {
        return item;
    }
}

export default ComponentLookitPricepillComponent;